import Modal from "../Modal";
import { ReactNode } from "react";
import styled from "styled-components";

interface DrawerProps {
  children: ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
  width: string;
  maxWidth: string;
}

const VisibleDrawer = styled.div<{
  isOpen: boolean;
  width: string;
  maxWidth: string;
}>`
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
`;

export default function FlashPCBDrawer({
  children,
  isOpen,
  onRequestClose,
  width,
  maxWidth,
}: DrawerProps) {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          height: "100%",
        }}
      >
        <div onClick={onRequestClose} style={{ flex: 1 }} />
        <VisibleDrawer isOpen={isOpen} maxWidth={maxWidth} width={width}>
          {children}
        </VisibleDrawer>
      </div>
    </Modal>
  );
}
